/**
 * Set the app base uri to use when in development mode.
 */
export const LZ_APP_BASE_URI = 'http://2adata-services.local/';
